import React from "react";
import { Button } from "@/lib/components/ui/button";
import { GoogleIcon } from "@/lib/components/icons/google-icon";
import { forwardRef, HTMLAttributes } from "react";
import { useLogin } from "@/lib/hooks/use-login";

const Login = forwardRef<
  HTMLButtonElement,
  HTMLAttributes<HTMLButtonElement> & { noRedirect?: boolean }
>(({ noRedirect = false, ...props }, ref) => {
  const { isSigningIn, startLogin: startOauth } = useLogin();

  return (
    <Button
      ref={ref}
      onClick={() => startOauth(noRedirect)}
      variant="secondary"
      size="lg"
      disabled={isSigningIn}
      className="rounded-2xl drop-shadow-md font-semibold cursor-pointer border-2 border-solid border-[var(--border)]"
      {...props}
    >
      <GoogleIcon className="h-4 w-4" />
      Login
    </Button>
  );
});

export default Login;
